<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>Informacija</th>
          <th>Vrednost</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <td><strong>{{ item.label }}</strong></td>
          <td>{{ item.text }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  }
}
</script>
